import React from 'react';
import { CNPJMask } from '../../../components/Input/Masks';
import Input from '../../../components/Input/input.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import BuscaAvancada, { BuscaAvancadaContext } from '../../../components/BuscaAvancada/buscaAvancada.component';

const PesquisaAvancadaEntidade = (props) => {
	const {
		filtro, municipios, handlePesquisaSimplificada, serviceSearch, resetIconOrder,
	} = props;
	return (
		<BuscaAvancada
			initialValues={filtro}
			handleSearch={(values) => {
				const filtroFinal = {};
				Object.assign(filtroFinal, values);
				filtroFinal.idMunicipios = values.municipiosSelecionados.map(item => item.object.codigoIbge);
				serviceSearch(filtroFinal);
			}}
			handleClear={({ resetForm }) => {
				resetForm();
				resetIconOrder();
				filtro.isClearable = true;
				serviceSearch(filtro);
			}}
			handlePesquisaSimplificada={handlePesquisaSimplificada}
		>
			<BuscaAvancadaContext.Consumer>
				{({
					values,
					handleChange,
					setFieldValue,
				}) => (
					<React.Fragment>
						<div className='row'>
							<div className='col-12 mb-2'>
								<label>Entidade</label>
								<Input
									type='text'
									name='nome'
									onChange={handleChange}
									value={values.nome}
									maxLength='255'
								/>
							</div> {/* col-12 */}
						</div> {/* row */}
						<div className='row'>
							<div className='col-6'>
								<label>CNPJ</label>
								<Input
									placeholder='00.000.000/0000-00'
									name='cnpj'
									type='text'
									onChange={handleChange}
									mask={CNPJMask}
									value={values.cnpj}
								/>
							</div> {/* col-6 */}
							<div className='col-6'>
								<label>Município</label>
								<SelectMulti
									isMulti
									isClearable
									name='municipiosSelecionados'
									uniqueKey='codigoIbge'
									label='nome'
									value={values.municipiosSelecionados}
									onChange={(item) => {
										setFieldValue('municipiosSelecionados', item);
									}}
									options={municipios}
								/>
							</div> {/* col-6 */}
						</div> {/* row */}
					</React.Fragment>
				)}
			</BuscaAvancadaContext.Consumer>

		</BuscaAvancada>
	);
};


export default PesquisaAvancadaEntidade;
